import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import axios from "axios";
import settings from "../helpers/Settings";
let { KayanURL } = settings;
const MoreOptions = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <IconButton
        aria-label="more"
        onClick={handleClick}
        aria-haspopup="true"
        aria-controls="long-menu"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} keepMounted onClose={handleClose} open={open}>
        {props.optionFor === "patient" ? (

          <>
            <MenuItem onClick={props.handleUpdate}>Update</MenuItem>
            <MenuItem onClick={props.handleDelete}>Delete</MenuItem>
          </>

        ) :

          props.optionFor === "visit" ? (
            <>
              {" "}
              <MenuItem onClick={props.handleView}>View</MenuItem>
              <MenuItem onClick={props.handleDelete}>Delete</MenuItem>
            </>
          ) : props.optionFor === "Auth" ? (
            <>
              <MenuItem onClick={props.handleAuthSubmit}>
                Approval Request
              </MenuItem>
              <MenuItem onClick={props.handleAuthSubmit}>Edit</MenuItem>
            </>
          ) : props.optionFor === "Claim" ? (
            <MenuItem onClick={props.handleSubmit}>Submit</MenuItem>
          ) : props.claimsubmissionstatus === "Queued" ? (
            <MenuItem onClick={props.handleSubmit}>poll Request</MenuItem>
          ) : props.optionFor === "ClaimSubmission" ? (
            <MenuItem onClick={props.handleSubmit}>Submit</MenuItem>
          ) : /*  <MenuItem onClick={props.handleDelete}>Delete</MenuItem> */

            props.claimSubmissionstatus === "Queued" ? (
              <MenuItem onClick={props.handleSubmit}>poll Request</MenuItem>
            ) : null}
      </Menu>
    </div>
  );
};

export default MoreOptions;
